import styled from 'styled-components';
import { Label } from '@common/components/form/Label';

export const SpaAvailabilityWrapper = styled.div`
  padding: 0;
  display: grid;
  grid-template-columns: 1fr;
  align-items: center;
  gap: 10px;
  margin-bottom: 1rem;
  width: 100%;
  @media screen and (max-width: 850px) {
    border: ${({ theme }) => `1px solid ${theme.defaultColors.lightGrey}`};
    padding: 1rem;
    border-radius: 3px;
  }
`;

export const MultipleOptionsAvailabilityWrapper = styled.div`
  padding: 10px 0;
  display: grid;
  grid-template-columns: 1fr;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
`;

export const TitleWrapper = styled.div`
  display: grid;
  grid-template-columns: min-content 1fr;
  gap: 20px;
  white-space: nowrap;
  align-items: center;
`;

export const DividerLine = styled.div`
  height: 1px;
  border-top: 1px solid ${({ theme }) => theme.defaultColors.lightGrey};
`;

export const DropdownGridWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;

  @media (min-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

export const SubtitleWrapper = styled.div`
  color: ${({ theme }) => theme.defaultColors.grey};
`;

export const DropdownWrapper = styled.div`
  width: 100%;
  @media (min-width: 768px) {
    width: 50%;
  }
`;

export const SpaLabel = styled(Label)`
  margin: 0;
`;
